import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from '../../constants/global-constants';

@Component({
  selector: 'app-rat-select',
  templateUrl: './rat-select.component.html',
  styleUrls: ['./rat-select.component.css']
})
export class RatSelectComponent implements OnInit {

  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: number;
  @Input() form!: FormGroup;
  @Input() assessmentType!: string;
  @Output() inputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSubmittedEvent!: Observable<void>;

  isArabic!: boolean;
  isValid!: boolean;
  controlValue: any;
  isDisabled: any;
  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
    // console.log('test: ',this.eachControl.options);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isDisabled = this.eachControl.isDisabled;
    if (this.assessmentType === 'mainAssessment') {
      if (this.eachControl?.value == null || this.eachControl?.value == undefined ||
        // this.eachControl?.value == 'N/A'
        this.eachControl?.value == GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT
      ) {
        /* remove/add select option*/
        this.controlValue = '-1';
        // this.controlValue = this.eachControl?.options[0]?.value;
      } else {
        this.controlValue = this.eachControl?.value;
      }
      // console.log('input ques: --- ', this.question.quesId+'_id_'+this.controlIndex, ' ans: --- ', this.controlValue);
      this.form?.controls[this.question.quesId + '_id_' + this.controlIndex]?.setValue(this.controlValue);
      this.isSubmittedEvent.subscribe(() => {
        this.setValidation(this.controlValue, this.question.quesId + '_id_' + this.controlIndex);
      });
    }

  }
  getControl(): (AbstractControl | null) {
    return this.form.controls[this.question.quesId + '_id_' + this.controlIndex];
  }
  inputChange(evt: any, parentQuesId: any) {
    // console.log(evt.target.value);
    // console.log(parentQuesId);
    this.controlValue = evt.target.value;
    this.setValidation(this.controlValue, parentQuesId);
  }

  setValidation(selectedVal: any, parentQuesId: any) {
    // console.log(this.isValid);
    if (selectedVal == '-1') {
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setErrors({ 'required': true });
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].markAsTouched();
      this.isValid = false;
    }
    else {
      this.isValid = true;
    }
    this.inputChanged.emit({
      parentQuesId, parentQuesValue: selectedVal, quesValid: this.isValid,
      index: this.controlIndex,
      selectedValueIndex: [this.eachControl?.options?.findIndex((x: any) => x.value == selectedVal)]
    });
  }

}
